
import { IDoctorItem } from "@/models/doctor";
import { ListItem } from "@/models/common";
import ListItemVue from "@/components/common/ListItem.vue";
import { defineComponent, PropType, reactive } from "vue";

export default defineComponent({
  props: {
    doctor: {
      type: Object as PropType<IDoctorItem>,
      required: true,
    },
    isDefaultDetail: {
      type: Boolean,
      default: true,
    },
  },
  name: "doctor item",
  setup(props) {
    const state = reactive({
      doctor: new ListItem().DoctorItemToListItem(props.doctor),
      isDefaultDetail: props.isDefaultDetail,
    });

    return {
      state,
    };
  },
  components: {
    ListItemVue,
  },
});
